import React, { ReactNode } from 'react';

import Checkbox from 'components/Checkbox';
import { invert } from 'utils/functional';

import Field from './Field';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const CheckboxField = ({
  name,
  label,
  description,
  onChange,
  ...props
}: {
  large?: boolean;
  'data-qa-id'?: string;
  name: string;
  label: ReactNode;
  description?: string;
  toggle?: boolean;
  // An optional map of stored form value to checked state
  // Useful if you want to submit something other than true / false
  // E.g., {STATE1: true, STATE2: false}. Checked corresponds to
  // the string 'STATE1'
  // TODO: use ES6 map to extend past strings / avoid type issues
  valueToChecked?: Record<string, boolean>;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (...args: Array<any>) => any;
}) => (
  <Field
    inputProps={props}
    name={name}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => {
      const { valueToChecked } = props;
      const trueFalseMap = valueToChecked && invert(valueToChecked);
      const checked = (valueToChecked ? valueToChecked[value] : value) || false;
      return (
        <Checkbox
          id={id}
          name={name}
          label={label}
          checked={checked}
          hasError={hasError}
          onChange={(v) => {
            if (trueFalseMap) {
              updateValue(trueFalseMap[v.toString()]);
            } else {
              updateValue(v);
            }

            if (onChange) {
              onChange(v);
            }
          }}
          data-qa-id={qaId}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      );
    }}
  />
);

// eslint-disable-next-line import/no-default-export
export default CheckboxField;
